__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "portalPushMessaging";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("lodash", "4.17.21", () => (__webpack_require__.e(543).then(() => (() => (__webpack_require__(2543))))));
			register("moment-timezone", "0.5.46", () => (Promise.all([__webpack_require__.e(743), __webpack_require__.e(317)]).then(() => (() => (__webpack_require__(84743))))));
			register("moment", "2.30.1", () => (Promise.all([__webpack_require__.e(29), __webpack_require__.e(358)]).then(() => (() => (__webpack_require__(95093))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(225), __webpack_require__.e(278)]).then(() => (() => (__webpack_require__(61225))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(804), __webpack_require__.e(668)]).then(() => (() => (__webpack_require__(56804))))));
			register("react", "18.2.0", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("redux", "4.0.5", () => (__webpack_require__.e(960).then(() => (() => (__webpack_require__(82960))))));
			register("redux", "5.0.1", () => (__webpack_require__.e(880).then(() => (() => (__webpack_require__(17880))))));
			initExternal(41441);
			initExternal(83071);
			initExternal(77672);
			initExternal(41757);
			initExternal(96308);
			initExternal(42895);
			initExternal(513);
			initExternal(87176);
			initExternal(90990);
			initExternal(19347);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};